/* eslint-disable default-case */
$(document).ready(() => {
    // ROI Slider
    // $('#monthly_budget').slider();
    $('#monthly_budget').on('change', (slideEvt) => {
        $num = slideEvt.value.newValue;
        $output = $num.toLocaleString('pt');
        $('#budget_amount').text(`€ ${$output}`);
        $("input[name='monthly_budget']").val(slideEvt.value.newValue);
        $oldUrl = $('#monthly_budget_roi').attr('href');
        $removeBudget = $oldUrl.split('=')[0];
        $newUrl = `${$removeBudget}=${$("input[name='monthly_budget']").val()}`;
        $('#monthly_budget_roi').attr('href', $newUrl);
    });
    // ROI more and less buttons
    $('#less-budget').on('click', () => {
        if ($("input[name='monthly_budget']").val() > 1) {
            $current_budget = $("input[name='monthly_budget']").val();
            $("input[name='monthly_budget']").val(parseInt($current_budget) - 1);
            $output = parseInt($current_budget);
            $output_final = $output.toLocaleString('pt');
            $('#budget_amount').text(`€ ${$output_final}`);
            $('#monthly_budget').slider('setValue', parseInt($current_budget) - 1);
            $oldUrl = $('#monthly_budget_roi').attr('href');
            $removeBudget = $oldUrl.split('=')[0];
            $newUrl = `${$removeBudget}=${$("input[name='monthly_budget']").val()}`;
            $('#monthly_budget_roi').attr('href', $newUrl);
        }
    });
    $('#more-budget').on('click', () => {
        if ($("input[name='monthly_budget']").val() < 20000) {
            $current_budget = $("input[name='monthly_budget']").val();
            $("input[name='monthly_budget']").val(parseInt($current_budget) + 1);
            $output = parseInt($current_budget);
            $output_final = $output.toLocaleString('pt');
            $('#budget_amount').text(`€ ${$output_final}`);
            $('#monthly_budget').slider('setValue', parseInt($current_budget) + 1);
            $oldUrl = $('#monthly_budget_roi').attr('href');
            $removeBudget = $oldUrl.split('=')[0];
            $newUrl = `${$removeBudget}=${$("input[name='monthly_budget']").val()}`;
            $('#monthly_budget_roi').attr('href', $newUrl);
        }
    });
    // ROI Monthly Budget Button
    $('.btn-home_calculate').on('click', () => {
        $('#monthly_budget_roi').attr('href', `${$('#monthly_budget_roi').attr('href')}?budget=${$('[name="monthly_budget"]').val()}`);
    });
    // Carousel
    $('.carousel').carousel();
    $('.carousel-indicators li').each(function () {
        if (($(this).attr('data-slide-to') + 1) > $(this).attr('data-appear')) {
            $(this).addClass('d-none');
        } else {
            $(this).removeClass('d-none');
        }
    });
    // Blog
    $('.single_post').on('mouseover', function () {
        $(this).children('.infobox').find('img').attr('src', '/wp-content/themes/kwankotheme/assets/images/home/more_info_hover.png');
        $(this).children('.postbox').find('.pink_cover').css('background-color', 'rgba(233, 47, 97, 0.3)');
    });
    $('.single_post').on('mouseleave', function () {
        $(this).children('.infobox').find('img').attr('src', '/wp-content/themes/kwankotheme/assets/images/home/more_info.png');
        $(this).children('.postbox').find('.pink_cover').css('background-color', 'transparent');
    });
    // Map
    $('.map-pin').each(function () {
        $(this).on('click', () => {
            switch ($(this).data('location')) {
            case 'lisbon':
                $('#local_address').html('Av. da Liberdade 225, 6º Esq. <br>1250-142 Lisboa, Portugal');
                $('#local_phone').html('+351 21 421 8094');
                $('#local_email').html('sales.pt@kwanko.com');
                break;
            case 'madrid':
                $('#local_address').html('Calle Serrano 90, 6°a planta <br>28006 Madrid, España');
                $('#local_phone').html('+34 697 27 33 35');
                $('#local_email').html('sales.es@kwanko.com');
                break;
            case 'brussels':
                $('#local_address').html('Chaussée de Louvain, 435 <br>1380 Lasne, Belgium');
                $('#local_phone').html('+32 473 785460');
                $('#local_email').html('sales.be@kwanko.com');
                break;
            case 'paris':
                $('#local_address').html('60 boulevard du Maréchal Joffre <br>92340 Bourg-La-Reine, France');
                $('#local_phone').html('+33 1 70 68 97 20');
                $('#local_email').html('sales.fr@kwanko.com');
                break;
            case 'warsaw':
                $('#local_address').html('Grzybowska 4/144, 00-131, <br>Warszawa, Polska');
                $('#local_phone').html('+48 22 241 46 95');
                $('#local_email').html('sales.pl@kwanko.com');
                break;
            case 'hamburg':
                $('#local_address').html('Stadthaus Axel-Springer-Platz 3 <br>20355 Hamburg, Germany');
                $('#local_phone').html('+49 40 638 694 34');
                $('#local_email').html('sales.de@kwanko.com');
                break;
            case 'london':
                $('#local_address').html('9 Devonshire Square, Spitalfields, <br>London EC2M 4YD, United Kingdom');
                $('#local_phone').html('+44 757777 2225');
                $('#local_email').html('sales.uk@kwanko.com');
                break;
            case 'mexico':
                $('#local_address').html('Calle Varsovia 36 Col. Juarez, <br>Ciudad de México C.P. 06600 México');
                $('#local_phone').html('+52 5512091269');
                $('#local_email').html('sales.mx@kwanko.com');
                break;
            case 'saopaulo':
                $('#local_address').html('Rua Mourato Coelho 90 - Conj.22, <br>05417-010, São Paulo, Brazil');
                $('#local_phone').html('+55 11 2362-5072');
                $('#local_email').html('sales.br@kwanko.com');
                break;
            }
        });

        $(this).popover({
            placement: 'bottom',
            trigger: 'focus',
            html: true,
            content: `<img src="/wp-content/themes/kwankotheme/assets/images/home/landmarks/${$(this).data('location')}.svg">
            <h2>${$(this).data('location-name')}</h2>`,
        });
    });

    $('#location-select').on('change', function () {
        switch ($(this).val()) {
        case 'lisbon':
            $('#local_address').html('Av. da Liberdade 225, 6º Esq. <br>1250-142 Lisboa, Portugal');
            $('#local_phone').html('+351 21 421 8094');
            $('#local_email').html('sales.pt@kwanko.com');
            break;
        case 'madrid':
            $('#local_address').html('Calle Serrano 90, 6°a planta <br>28006 Madrid, España');
            $('#local_phone').html('+34 697 27 33 35');
            $('#local_email').html('sales.es@kwanko.com');
            break;
        case 'brussels':
            $('#local_address').html('Chaussée de Louvain, 435 <br>1380 Lasne, Belgium');
            $('#local_phone').html('+32 473 785460');
            $('#local_email').html('sales.be@kwanko.com');
            break;
        case 'paris':
            $('#local_address').html('60 boulevard du Maréchal Joffre <br>92340 Bourg-La-Reine, France');
            $('#local_phone').html('+33 1 70 68 97 20');
            $('#local_email').html('sales.fr@kwanko.com');
            break;
        case 'warsaw':
            $('#local_address').html('Grzybowska 4/144, 00-131, <br>Warszawa, Polska');
            $('#local_phone').html('+48 22 241 46 95');
            $('#local_email').html('sales.pl@kwanko.com');
            break;
        case 'hamburg':
            $('#local_address').html('Stadthaus Axel-Springer-Platz 3 <br>20355 Hamburg, Germany');
            $('#local_phone').html('+49 40 638 694 34');
            $('#local_email').html('sales.de@kwanko.com');
            break;
        case 'london':
            $('#local_address').html('9 Devonshire Square, Spitalfields, <br>London EC2M 4YD, United Kingdom');
            $('#local_phone').html('+44 757777 2225');
            $('#local_email').html('sales.uk@kwanko.com');
            break;
        case 'mexico':
            $('#local_address').html('Calle Varsovia 36 Col. Juarez, <br>Ciudad de México C.P. 06600 México');
            $('#local_phone').html('+52 5512091269');
            $('#local_email').html('sales.mx@kwanko.com');
            break;
        case 'saopaulo':
            $('#local_address').html('Rua Mourato Coelho 90 - Conj.22, <br>05417-010, São Paulo, Brazil');
            $('#local_phone').html('+55 11 2362-5072');
            $('#local_email').html('sales.br@kwanko.com');
            break;
        }
    });

    // Alert to show Newpage Ad only once!
    //     var alerted = localStorage.getItem('alerted') || '';
    //     if (alerted != 'yes') {
    //         $('#newpage_ad').modal('show')
    //         localStorage.setItem('alerted','yes');
    //     }

    // Show and Hide Logos Desktop
    $('#case_studies_view_all').on('click', function () {
        $('.view-category').removeClass('active');
        $(this).addClass('active');
        $('.logos-list').addClass('d-none');
        $('.logos-all').removeClass('d-none');
    });
    $('#case_studies_telco').on('click', function () {
        $('.view-category').removeClass('active');
        $(this).addClass('active');
        $('.logos-list').addClass('d-none');
        $('.logos-telco').removeClass('d-none');
    });
    $('#case_studies_energy').on('click', function () {
        $('.view-category').removeClass('active');
        $(this).addClass('active');
        $('.logos-list').addClass('d-none');
        $('.logos-energy').removeClass('d-none');
    });
    $('#case_studies_automotive').on('click', function () {
        $('.view-category').removeClass('active');
        $(this).addClass('active');
        $('.logos-list').addClass('d-none');
        $('.logos-automotive').removeClass('d-none');
    });
    $('#case_studies_insurance').on('click', function () {
        $('.view-category').removeClass('active');
        $(this).addClass('active');
        $('.logos-list').addClass('d-none');
        $('.logos-insurance').removeClass('d-none');
    });
    $('#case_studies_finance').on('click', function () {
        $('.view-category').removeClass('active');
        $(this).addClass('active');
        $('.logos-list').addClass('d-none');
        $('.logos-finance').removeClass('d-none');
    });
    $('#case_studies_ecommerce').on('click', function () {
        $('.view-category').removeClass('active');
        $(this).addClass('active');
        $('.logos-list').addClass('d-none');
        $('.logos-ecommerce').removeClass('d-none');
    });
    $('#case_studies_travel').on('click', function () {
        $('.view-category').removeClass('active');
        $(this).addClass('active');
        $('.logos-list').addClass('d-none');
        $('.logos-travel').removeClass('d-none');
    });
    $('#case_studies_education').on('click', function () {
        $('.view-category').removeClass('active');
        $(this).addClass('active');
        $('.logos-list').addClass('d-none');
        $('.logos-education').removeClass('d-none');
    });
    $('#case_studies_realestate').on('click', function () {
        $('.view-category').removeClass('active');
        $(this).addClass('active');
        $('.logos-list').addClass('d-none');
        $('.logos-realestate').removeClass('d-none');
    });
    // Show and Hide Our Clients Mobile
    $('#input-category').on('change', function () {
        console.log('changed');
        if ($('#input-category').val() == 'case_studies_view_all') {
            $('.view-category').removeClass('active');
            $(this).addClass('active');
            $('.logos-list').addClass('d-none');
            $('.logos-all').removeClass('d-none');
        }
        if ($('#input-category').val() == 'case_studies_telco') {
            $('.view-category').removeClass('active');
            $(this).addClass('active');
            $('.logos-list').addClass('d-none');
            $('.logos-telco').removeClass('d-none');
        }
        if ($('#input-category').val() == 'case_studies_energy') {
            $('.view-category').removeClass('active');
            $(this).addClass('active');
            $('.logos-list').addClass('d-none');
            $('.logos-energy').removeClass('d-none');
        }
        if ($('#input-category').val() == 'case_studies_automotive') {
            $('.view-category').removeClass('active');
            $(this).addClass('active');
            $('.logos-list').addClass('d-none');
            $('.logos-automotive').removeClass('d-none');
        }
        if ($('#input-category').val() == 'case_studies_insurance') {
            $('.view-category').removeClass('active');
            $(this).addClass('active');
            $('.logos-list').addClass('d-none');
            $('.logos-insurance').removeClass('d-none');
        }
        if ($('#input-category').val() == 'case_studies_finance') {
            $('.view-category').removeClass('active');
            $(this).addClass('active');
            $('.logos-list').addClass('d-none');
            $('.logos-finance').removeClass('d-none');
        }
        if ($('#input-category').val() == 'case_studies_ecommerce') {
            $('.view-category').removeClass('active');
            $(this).addClass('active');
            $('.logos-list').addClass('d-none');
            $('.logos-ecommerce').removeClass('d-none');
        }
        if ($('#input-category').val() == 'case_studies_travel') {
            $('.view-category').removeClass('active');
            $(this).addClass('active');
            $('.logos-list').addClass('d-none');
            $('.logos-travel').removeClass('d-none');
        }
        if ($('#input-category').val() == 'case_studies_education') {
            $('.view-category').removeClass('active');
            $(this).addClass('active');
            $('.logos-list').addClass('d-none');
            $('.logos-education').removeClass('d-none');
        }
        if ($('#input-category').val() == 'case_studies_realestate') {
            $('.view-category').removeClass('active');
            $(this).addClass('active');
            $('.logos-list').addClass('d-none');
            $('.logos-realestate').removeClass('d-none');
        }
    });
    // Lazy Load Images
    !(function (t, e) {
        function r(r, a, i, u, l) { function f() { L = t.devicePixelRatio > 1, i = c(i), a.delay >= 0 && setTimeout(() => { s(!0); }, a.delay), (a.delay < 0 || a.combined) && (u.e = v(a.throttle, (t) => { t.type === 'resize' && (w = B = -1), s(t.all); }), u.a = function (t) { t = c(t), i.push.apply(i, t); }, u.g = function () { return i = n(i).filter(function () { return !n(this).data(a.loadedName); }); }, u.f = function (t) { for (var e = 0; e < t.length; e++) { const r = i.filter(function () { return this === t[e]; }); r.length && s(!1, r); } }, s(), n(a.appendScroll).on(`scroll.${l} resize.${l}`, u.e)); } function c(t) { const i = a.defaultImage; const o = a.placeholder; const u = a.imageBase; const l = a.srcsetAttribute; const f = a.loaderAttribute; const c = a._f || {}; t = n(t).filter(function () { const t = n(this); const r = m(this); return !t.data(a.handledName) && (t.attr(a.attribute) || t.attr(l) || t.attr(f) || c[r] !== e); }).data(`plugin_${a.name}`, r); for (let s = 0, d = t.length; s < d; s++) { const A = n(t[s]); const g = m(t[s]); const h = A.attr(a.imageBaseAttribute) || u; g === N && h && A.attr(l) && A.attr(l, b(A.attr(l), h)), c[g] === e || A.attr(f) || A.attr(f, c[g]), g === N && i && !A.attr(E) ? A.attr(E, i) : g === N || !o || A.css(O) && A.css(O) !== 'none' || A.css(O, `url('${o}')`); } return t; } function s(t, e) { if (!i.length) return void (a.autoDestroy && r.destroy()); for (var o = e || i, u = !1, l = a.imageBase || '', f = a.srcsetAttribute, c = a.handledName, s = 0; s < o.length; s++) if (t || e || A(o[s])) { const g = n(o[s]); const h = m(o[s]); const b = g.attr(a.attribute); const v = g.attr(a.imageBaseAttribute) || l; const p = g.attr(a.loaderAttribute); g.data(c) || a.visibleOnly && !g.is(':visible') || !((b || g.attr(f)) && (h === N && (v + b !== g.attr(E) || g.attr(f) !== g.attr(F)) || h !== N && v + b !== g.css(O)) || p) || (u = !0, g.data(c, !0), d(g, h, v, p)); } u && (i = n(i).filter(function () { return !n(this).data(c); })); } function d(t, e, r, i) { ++z; var o = function () { y('onError', t), p(), o = n.noop; }; y('beforeLoad', t); const u = a.attribute; const l = a.srcsetAttribute; const f = a.sizesAttribute; const c = a.retinaAttribute; const s = a.removeAttribute; const d = a.loadedName; const A = t.attr(c); if (i) { var g = function () { s && t.removeAttr(a.loaderAttribute), t.data(d, !0), y(T, t), setTimeout(p, 1), g = n.noop; }; t.off(I).one(I, o).one(D, g), y(i, t, (e) => { e ? (t.off(D), g()) : (t.off(I), o()); }) || t.trigger(I); } else { const h = n(new Image()); h.one(I, o).one(D, () => { t.hide(), e === N ? t.attr(C, h.attr(C)).attr(F, h.attr(F)).attr(E, h.attr(E)) : t.css(O, `url('${h.attr(E)}')`), t[a.effect](a.effectTime), s && (t.removeAttr(`${u} ${l} ${c} ${a.imageBaseAttribute}`), f !== C && t.removeAttr(f)), t.data(d, !0), y(T, t), h.remove(), p(); }); const m = (L && A ? A : t.attr(u)) || ''; h.attr(C, t.attr(f)).attr(F, t.attr(l)).attr(E, m ? r + m : null), h.complete && h.trigger(D); } } function A(t) { const e = t.getBoundingClientRect(); const r = a.scrollDirection; const n = a.threshold; const i = h() + n > e.top && -n < e.bottom; const o = g() + n > e.left && -n < e.right; return r === 'vertical' ? i : r === 'horizontal' ? o : i && o; } function g() { return w >= 0 ? w : w = n(t).width(); } function h() { return B >= 0 ? B : B = n(t).height(); } function m(t) { return t.tagName.toLowerCase(); } function b(t, e) { if (e) { const r = t.split(','); t = ''; for (let a = 0, n = r.length; a < n; a++)t += e + r[a].trim() + (a !== n - 1 ? ',' : ''); } return t; } function v(t, e) { let n; let i = 0; return function (o, u) { function l() { i = +new Date(), e.call(r, o); } const f = +new Date() - i; n && clearTimeout(n), f > t || !a.enableThrottle || u ? l() : n = setTimeout(l, t - f); }; } function p() { --z, i.length || z || y('onFinishedAll'); } function y(t, e, n) { return !!(t = a[t]) && (t.apply(r, [].slice.call(arguments, 1)), !0); } var z = 0; var w = -1; var B = -1; var L = !1; var T = 'afterLoad'; var D = 'load'; var I = 'error'; var N = 'img'; var E = 'src'; var F = 'srcset'; var C = 'sizes'; var O = 'background-image'; a.bind === 'event' || o ? f() : n(t).on(`${D}.${l}`, f); } function a(a, o) { const u = this; const l = n.extend({}, u.config, o); let f = {}; const c = `${l.name}-${++i}`; return u.config = function (t, r) { return r === e ? l[t] : (l[t] = r, u); }, u.addItems = function (t) { return f.a && f.a(n.type(t) === 'string' ? n(t) : t), u; }, u.getItems = function () { return f.g ? f.g() : {}; }, u.update = function (t) { return f.e && f.e({}, !t), u; }, u.force = function (t) { return f.f && f.f(n.type(t) === 'string' ? n(t) : t), u; }, u.loadAll = function () { return f.e && f.e({ all: !0 }, !0), u; }, u.destroy = function () { return n(l.appendScroll).off(`.${c}`, f.e), n(t).off(`.${c}`), f = {}, e; }, r(u, l, a, f, c), l.chainable ? a : u; } var n = t.jQuery || t.Zepto; var i = 0; var o = !1; n.fn.Lazy = n.fn.lazy = function (t) { return new a(this, t); }, n.Lazy = n.lazy = function (t, r, i) { if (n.isFunction(r) && (i = r, r = []), n.isFunction(i)) { t = n.isArray(t) ? t : [t], r = n.isArray(r) ? r : [r]; for (var o = a.prototype.config, u = o._f || (o._f = {}), l = 0, f = t.length; l < f; l++)(o[t[l]] === e || n.isFunction(o[t[l]])) && (o[t[l]] = i); for (let c = 0, s = r.length; c < s; c++)u[r[c]] = t[0]; } }, a.prototype.config = {
            name: 'lazy', chainable: !0, autoDestroy: !0, bind: 'load', threshold: 500, visibleOnly: !1, appendScroll: t, scrollDirection: 'both', imageBase: null, defaultImage: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==', placeholder: null, delay: -1, combined: !1, attribute: 'data-src', srcsetAttribute: 'data-srcset', sizesAttribute: 'data-sizes', retinaAttribute: 'data-retina', loaderAttribute: 'data-loader', imageBaseAttribute: 'data-imagebase', removeAttribute: !0, handledName: 'handled', loadedName: 'loaded', effect: 'show', effectTime: 0, enableThrottle: !0, throttle: 250, beforeLoad: e, afterLoad: e, onError: e, onFinishedAll: e,
        }, n(t).on('load', () => { o = !0; });
    }(window));
    $(() => {
        $('.lazy').lazy();
    });
    // Redirect homepage if browser not in EN
    if (window.location.href == 'https://www.kwanko.com/') {
        function getFirstBrowserLanguage() {
            const nav = window.navigator; const browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage']; let i; let language; let len; let
                shortLanguage = null;
            // support for HTML 5.1 "navigator.languages"
            if (Array.isArray(nav.languages)) {
                for (i = 0; i < nav.languages.length; i++) {
                    language = nav.languages[i];
                    len = language.length;
                    if (!shortLanguage && len) {
                        shortLanguage = language;
                    }
                    if (language && len > 2) {
                        return language;
                    }
                }
            }
            // support for other well known properties in browsers
            for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
                language = nav[browserLanguagePropertyKeys[i]];
                len = language.length;
                if (!shortLanguage && len) {
                    shortLanguage = language;
                }
                if (language && len > 2) {
                    return language;
                }
            }
            return shortLanguage;
        }
        if (getFirstBrowserLanguage().includes('en')) {
            // console.log('I am a teacup.')
        } if (getFirstBrowserLanguage().includes('fr')) {
            window.location.replace('https://www.kwanko.com/fr');
        } if (getFirstBrowserLanguage().includes('pt')) {
            window.location.replace('https://www.kwanko.com/pt');
        }
    }
    // Increase Stats Animation
    // let seen = 0;
    // $(window).scroll(() => {
    // 	const section_height = $('#counter').offset().top - window.innerHeight;
    // 	if (seen == 0 && $(window).scrollTop() > section_height) {
    // 		$('.counter-value').each(function () {
    // 			const $this = $(this);
    // 			const countTo = $this.attr('data-count');
    // 			$({ countNum: $this.text() }).animate({ countNum: countTo },
    // 				{
    // 					duration: 3000,
    // 					easing: 'swing',
    // 					step() {
    // 						$this.text(Math.floor(this.countNum));
    // 					},
    // 					complete() {
    // 						$this.text(this.countNum);
    // 					},
    // 				});
    // 		});
    // 		seen = 1;
    // 	}
    // });
});
